import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "../config/business";

const NAV_ITEMS = [
  { to: "/decking-cost-calculator-melbourne", label: "Calculator" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkCls = ({ isActive }) =>
    [
      "text-[15px] tracking-wide transition-colors font-medium",
      isActive
        ? "text-[#7A2D2F]"
        : "text-[#4A4D4A] hover:text-[#7A2D2F]",
    ].join(" ");

  const isHome =
    location.pathname === "/" ||
    location.pathname === "/decking-cost-calculator-melbourne";

  return (
    <header
      className="sticky top-0 z-40 w-full bg-[#F8F7F4]/85 backdrop-blur-md border-b border-[#DCD7CE]"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[80px] md:h-[88px] flex items-center justify-between">
        <Link
          to={isHome ? "/" : "/"}
          className="flex items-center gap-3 group"
          data-testid="nav-logo-link"
          aria-label="Woodstone Construction — Home"
        >
          {/* Logo — update BUSINESS.logoUrl in config/business.js.
              mix-blend-multiply lets the black logo background merge with
              the cream navbar so only the maroon wordmark shows. */}
          <img
            src={BUSINESS.logoUrl}
            alt="Woodstone Construction"
            className="h-14 md:h-16 w-auto object-contain mix-blend-multiply transition-transform group-hover:-translate-y-0.5"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10" aria-label="Primary">
          {NAV_ITEMS.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              className={linkCls}
              data-testid={`nav-link-${it.label.toLowerCase()}`}
            >
              {it.label}
            </NavLink>
          ))}
          <a
            href={`tel:${BUSINESS.phone}`}
            className="inline-flex items-center gap-2 bg-[#7A2D2F] text-white rounded-full px-5 py-2.5 text-sm font-semibold hover:bg-[#0D0D0E] transition-all hover:-translate-y-0.5 shadow-sm"
            data-testid="nav-call-btn"
          >
            <Phone size={15} strokeWidth={2} />
            {BUSINESS.phoneDisplay}
          </a>
        </nav>

        <button
          className="md:hidden p-2 text-[#1A1A1A]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t border-[#DCD7CE] bg-[#F8F7F4]"
          data-testid="nav-mobile-menu"
        >
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV_ITEMS.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                onClick={() => setOpen(false)}
                className={linkCls}
                data-testid={`nav-mobile-link-${it.label.toLowerCase()}`}
              >
                {it.label}
              </NavLink>
            ))}
            <a
              href={`tel:${BUSINESS.phone}`}
              className="inline-flex items-center gap-2 bg-[#7A2D2F] text-white rounded-full px-5 py-2.5 text-sm font-semibold w-fit"
              data-testid="nav-mobile-call-btn"
            >
              <Phone size={15} /> {BUSINESS.phoneDisplay}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
